<template>
  <div class="page-container tag-page">
    <portal to="page-name">Cadastro de tag</portal>
    <div class="card card-page">
      <div class="card-header">
        <h1 class="card-title">Cadastro de tag</h1>
      </div>
      <div class="card-body">
        <div v-if="loading" class="loading loading-lg" />
        <div v-else class="columns form-group">
          <div class="column col-8 form-group"
               :class="{'has-error': $v.form.name.$error}">
            <label for="name" class="form-label">Nome</label>
            <input type="text"
                   class="form-input"
                   v-model="form.name"
                   @change="$v.form.name.$touch()"
                   placeholder="Informe o nome da tag"
            >
            <template v-if="$v.form.name.$error">
              <div class="form-input-hint"
                   v-if="!$v.form.name.required">Campo obrigatório</div>
            </template>
          </div>
          <div class="column col-4 col-md-6 col-sm-12 form-group">
            <label for="type" class="form-label">Tipo</label>
            <select id="type" name="type" class="form-select"
                    v-model="form.type">
              <option v-for="(text, value) in tagType.types"
                      :value="value" :key="value">{{ text }}</option>
            </select>
          </div>
          <div class="column col-12 form-group">
            <label for="notes" class="form-label">Observações</label>
            <textarea
              id="notes"
              class="form-input"
              v-model="form.notes"
            />
          </div>
        </div>
      </div>
      <div class="card-footer">
        <button
          v-if="!loading"
          class="btn btn-primary mr-1"
          :class="{loading: saving}"
          @click="save()"
          :disabled="saving"
        >
          Salvar
        </button>
        <button class="btn" @click="$router.back()">
          Voltar
        </button>
      </div>
    </div>
  </div>
</template>

<script>
import { required } from 'vuelidate/src/validators';
import formMixin from 'src/mixins/form';
import { mergeFrom } from '@/helpers/object';
import * as tagType from 'src/data/tag-types';

export default {
  mixins: [formMixin],
  data() {
    return {
      tagType,
      isNew: true,
      loading: false,
      saving: false,
      form: this.blankForm(),
    };
  },
  async mounted() {
    this.isNew = /create$/.test(this.$route.path);
    if (!this.isNew) {
      this.form.id = this.$route.params.id;
      this.load();
    }
  },
  validations() {
    return {
      form: {
        name: { required },
        type: { required },
      },
    };
  },
  methods: {
    load() {
      this.loading = true;

      return this.$http
        .get(`/tags/${this.form.id}`)
        .then(({ data }) => {
          this.form = mergeFrom(this.blankForm(), data);
        })
        .catch(() => {
          this.$toast.error('Ocorreu um erro ao carregar os dados.');
        })
        .finally(() => {
          this.loading = false;
        });
    },
    async save() {
      this.$v.form.$touch();
      if (this.$v.form.$error) {
        return;
      }

      this.saving = true;

      const payload = this.clone(this.form);

      const request = this.isNew
        ? this.$http.post('/tags', payload)
        : this.$http.put(`/tags/${this.form.id}`, payload);

      // eslint-disable-next-line consistent-return
      return request
        .then(({ data }) => {
          if (this.isNew) {
            this.$router.replace(`/settings/tags/${data.id}/edit`);
            this.isNew = false;
            this.form.id = data.id;
          }
          this.$toast.show('Registro salvo.');
        })
        .catch(() => {
          this.$toast.error('Ocorreu um erro ao salvar o registro.');
        })
        .finally(() => {
          this.saving = false;
        });
    },
    blankForm() {
      return {
        id: '',
        name: '',
        type: 'medical_record',
        notes: '',
      };
    },
  },
};
</script>
